"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateStateFromMultiselectItem = exports.saveSearchesDidChange = void 0;
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const lodash_1 = require("lodash");
const DatePicker_1 = require("../../DatePicker");
const AutocompleteCheckboxes_1 = require("../../../containers/AutocompleteCheckboxes");
const SelectableList_1 = require("./SelectableList");
const AddFilterButton_1 = __importDefault(require("./AddFilterButton/AddFilterButton"));
const utils_1 = require("../utils");
const Wrapper = (0, material_1.styled)("div")(({ theme }) => ({
    display: "flex",
    borderBottom: `1px solid ${theme.palette.divider}`,
    borderTop: `1px solid ${theme.palette.divider}`,
}));
const ColumnsContainer = (0, material_1.styled)("div")({
    display: "flex",
    flex: "1 1 auto",
    overflowX: "auto",
});
const ColumnContainer = (0, material_1.styled)("div")(({ theme }) => ({
    width: "100%",
    maxWidth: 360,
    overflow: "auto",
    maxHeight: 270,
    borderRight: `1px solid ${theme.palette.divider}`,
    minWidth: 200,
}));
const DatePickerContainer = (0, material_1.styled)("div")(({ theme }) => ({
    padding: theme.spacing(2),
}));
const InputContainer = (0, material_1.styled)("div")(({ theme }) => ({
    padding: theme.spacing(3),
}));
const CheckboxesContainer = (0, material_1.styled)("div")(({ theme }) => ({
    padding: theme.spacing(3),
}));
const SelectContainer = (0, material_1.styled)("div")(({ theme }) => ({
    padding: theme.spacing(3),
}));
const saveSearchesDidChange = (previewsLength, currentLength, columns, listSelectionHandler, objectType) => {
    if (previewsLength > currentLength) {
        const savedSearchColumnIndex = columns.findIndex((obj) => obj.id === objectType);
        listSelectionHandler(savedSearchColumnIndex)("userSaved");
    }
};
exports.saveSearchesDidChange = saveSearchesDidChange;
const updateStateFromMultiselectItem = (val, currentState, updateState) => {
    if (val.length) {
        updateState({
            ...currentState,
            value: val.map(({ id }) => id),
            valueLabel: val.map(({ label }) => label),
        });
    }
    else {
        updateState({
            ...currentState,
            value: null,
            valueLabel: null,
        });
    }
};
exports.updateStateFromMultiselectItem = updateStateFromMultiselectItem;
const FilterColumns = ({ onAdd, onSelectSavedSearch = lodash_1.noop, options, deleteSavedSearch, objectType, savedSearches, onError, search, }) => {
    const initialState = {
        columns: [options],
        additionalFilters: [],
    };
    const [state, updateState] = (0, react_1.useState)({ ...initialState });
    const { columns, description, value, operator, category, path, subject, additionalFilters, subjectLabel, valueLabel, } = state;
    const reset = () => {
        const resetState = { ...initialState };
        updateState(resetState);
    };
    const handleListSelection = (columnIndex) => (id) => {
        const column = columns[columnIndex];
        const selectedItem = (0, lodash_1.find)(column.items, { id });
        if (selectedItem?.type === "savedSearch") {
            onSelectSavedSearch(selectedItem);
        }
        else {
            const { sectionId, ...rest } = selectedItem;
            updateState({
                ...(sectionId ? { ...initialState, columns: [...columns] } : state),
                category: sectionId ?? state.category,
                columns: [
                    ...columns.slice(0, columnIndex + 1),
                    selectedItem,
                ],
                ...rest,
            });
        }
    };
    // listen to changes to adv search config (saved search updates)
    (0, react_1.useEffect)(() => {
        updateState({ ...state, columns: [options] });
    }, [options]);
    // if a saved search is deleted, reselect saved search section for better UX
    const savedSearchesRef = (0, react_1.useRef)(savedSearches.length);
    (0, react_1.useEffect)(() => {
        (0, exports.saveSearchesDidChange)(savedSearchesRef.current, savedSearches.length, columns, handleListSelection, objectType);
        savedSearchesRef.current = savedSearches.length;
    }, [columns]);
    const handleAdd = () => {
        const displayedValue = (0, utils_1.getDisplayedFilterValue)(value);
        const filterToAdd = {
            label: description,
            operator,
            value,
            displayedValue,
            category,
            path,
        };
        if (subject) {
            filterToAdd.subjects = [subject];
            filterToAdd.label = `${description} (${subjectLabel})`;
            filterToAdd.additionalFilters = additionalFilters;
        }
        // if path is either hraAssessable/virtualCareAssessable, change displayValue to custom string
        // that includes Tier information (when multiple values are selected, use default displayValue
        // created from getDisplayedFilterValue)
        if ((path === "hraAssessable" || path === "virtualCareAssessable") &&
            valueLabel?.length === 1) {
            filterToAdd.displayedValue = `
        ${description?.includes("HRA") ? "HRA" : "VC"} CDPS/MRX list: ${valueLabel?.toString()} 
        `;
        }
        if (onAdd) {
            onAdd(filterToAdd);
        }
        reset();
    };
    const handlerUpdateMultiSelect = (_, val) => {
        (0, exports.updateStateFromMultiselectItem)(val, state, updateState);
    };
    return (react_1.default.createElement(Wrapper, null,
        react_1.default.createElement(ColumnsContainer, { "data-testid": "advanced-search-options-list" }, options
            ? columns.map((column, columnIndex) => (react_1.default.createElement(ColumnContainer, { sx: column.sectionId === "savedSearches" ||
                    column.type === "multiselect"
                    ? {
                        maxWidth: "none",
                        minWidth: 400,
                    }
                    : {}, key: `column-${column.id}` },
                column.type === "selectableList" && (react_1.default.createElement("div", null,
                    react_1.default.createElement(SelectableList_1.SelectableList, { items: column.items, sections: column.sections, onChange: handleListSelection(columnIndex), deleteSavedSearch: deleteSavedSearch, objectType: objectType }))),
                column.type === "datePicker" && (react_1.default.createElement(DatePickerContainer, null,
                    react_1.default.createElement(DatePicker_1.DatePicker, { onChange: (data) => updateState({ ...state, value: data }), date: column.value }))),
                (column.type === "text" || column.type === "number") && (react_1.default.createElement(InputContainer, null,
                    react_1.default.createElement(material_1.TextField, { autoFocus: true, margin: "dense", "data-testid": `${column.id}_input`, label: column.label || "Search", fullWidth: true, helperText: column.helperText, required: true, onChange: (event) => {
                            updateState({ ...state, value: event.target.value });
                        }, type: column.type }))),
                column.type === "multiselect" && (react_1.default.createElement(CheckboxesContainer, null,
                    react_1.default.createElement(AutocompleteCheckboxes_1.AutocompleteCheckboxes, { "data-testid": "AutocompleteCheckboxes_root", options: column.options, label: column.label, onChange: handlerUpdateMultiSelect, optionsContext: column.context, shouldLaunchRequest: !!column.context, onError: onError, search: search }))),
                column.type === "select" && (react_1.default.createElement(SelectContainer, null,
                    react_1.default.createElement(material_1.FormControl, { fullWidth: true, required: true },
                        react_1.default.createElement(material_1.Select, { "data-testid": `${column.id}_select`, value: value, onChange: (event) => {
                                updateState({
                                    ...state,
                                    value: event.target.value,
                                });
                            } }, column.options?.map(({ id, label }) => (react_1.default.createElement(material_1.MenuItem, { key: id, value: id }, label))))))))))
            : null),
        react_1.default.createElement(AddFilterButton_1.default, { onClick: handleAdd, disabled: (!value && !(0, lodash_1.isBoolean)(value)) || !operator })));
};
exports.default = FilterColumns;
